import { FC, lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { LazyComponent } from '../features/lazy-component'

const Genesis = lazy(() => import('../__legacy__/components/genesis/Homepage'))

const GenesisPage: FC = () => (
  <LazyComponent>
    <Genesis />
  </LazyComponent>
)

export const GenesisRoute: RouteObject = {
  path: '/genesis',
  element: <GenesisPage />
}
